import { Edit, Event, People, Visibility, Upgrade } from "@mui/icons-material";
import type { MenuRoute } from "./MenuRoute";

export const OrganizationRoutes = (organizationId?: string): MenuRoute[] => [
  {
    text: "View Organization",
    href: `/?organization=${organizationId}`,
    icon: () => <Visibility />,
  },
  {
    text: "Edit Organization",
    href: `/account/organizations/${organizationId}`,
    icon: () => <Edit />,
  },
  { text: "My Events", href: "/account/events", icon: () => <Event /> },
  {
    text: "My Plan",
    href: "/subscription",
    icon: () => <Upgrade />,
  },
  {
    text: "Users",
    href: `/account/organizations/${organizationId}/users`,
    icon: () => <People />,
  },
  // TODO: unhide Followers when ready to release
  // {
  //   text: "Followers",
  //   href: `/account/organizations/${organizationId}/followers`,
  //   icon: () => <Bookmark />,
  // },
];
